export default __webpack_public_path__ + "static/media/nbmon3.c07aafaa.png";